import { ImageFieldImage } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import Link from 'next/link';

type BaseProps = {
  avatarClassName?: string;
};

type Props =
  | (BaseProps & {
      variation: 'default';
      name: string;
      avatar?: ImageFieldImage;
      jobTitle?: string | null;
      companyName?: string | null;
      authorUid?: string;
    })
  | (BaseProps & {
      variation: 'date_and_time';
      name: string;
      avatar?: ImageFieldImage;
      date: string;
      duration: number | null;
      authorUid?: string;
    })
  | (BaseProps & {
      variation: 'blog-post';
      avatar?: ImageFieldImage;
      date: string;
      duration: number | null;
      authorUid?: string;
    });
export const AuthorCard = (props: Props) => {
  const { authorUid = 'devsu' } = props;

  const renderDateAndDuration = (date: string, duration: number | null) => {
    if (props.variation === 'blog-post') {
      const parsedDate = new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });

      const parts = parsedDate.split(' '); // -> ['26', 'June', '2025']
      const parsedDateWithComma = `${parts[0]} ${parts[1]}, ${parts[2]}`;

      const parsedDuration = duration ? `${duration} minutes read` : '';

      return (
        <div className="flex flex-col items-center gap-2">
          <span>{parsedDateWithComma}</span>
          <span>{parsedDuration}</span>
        </div>
      );
    }

    const parsedDate = new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    const parsedDuration = duration ? `• ${duration} min` : '';
    return (
      <div>
        {parsedDate} {parsedDuration}
      </div>
    );
  };

  const renderTitleAndCompany = (
    company?: string | null,
    title?: string | null,
  ) => {
    const parsedTitle = title ? `${title},` : '';
    const parsedCompany = company ?? '';
    return (
      <div>
        {parsedTitle} {parsedCompany}
      </div>
    );
  };

  if (props.variation === 'date_and_time') {
    return (
      <Link
        href={`/blog/authors/${authorUid}`}
        className="cursor-pointer group"
      >
        <div className="flex gap-4">
          <PrismicNextImage
            field={props.avatar}
            className={
              props.avatarClassName ?? 'rounded-[50%] h-14 w-14 object-cover'
            }
            height={56}
          />
          <div className="flex flex-col justify-end text-sm">
            <div className="font-semibold mb-2 group-hover:underline">
              {props?.name}
            </div>
            <div>{renderDateAndDuration(props.date, props.duration)}</div>
          </div>
        </div>
      </Link>
    );
  }

  if (props.variation === 'blog-post') {
    return (
      <Link
        href={`/blog/authors/${authorUid}`}
        className="cursor-pointer group"
      >
        <div className="flex flex-col items-center gap-4">
          <PrismicNextImage
            field={props.avatar}
            className="rounded-[50%] h-14"
            height={56}
          />
          <div className="flex flex-col items-center text-sm">
            {renderDateAndDuration(props.date, props.duration)}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link href={`/blog/authors/${authorUid}`} className="cursor-pointer group">
      <div className="flex gap-4">
        <PrismicNextImage
          field={props.avatar}
          className="rounded-[50%] h-14"
          height={56}
        />
        <div className="flex flex-col justify-center text-sm">
          <div className="font-semibold mb-2 group-hover:underline">
            {props?.name}
          </div>
          <div>{renderTitleAndCompany(props.companyName, props.jobTitle)}</div>
        </div>
      </div>
    </Link>
  );
};
